import React from 'react';
import { find, sumBy } from 'lodash';

import { BarChart } from '@magoosh/lib/charts';

import StatisticData from '../statistic_data';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  filters: any;
}

const PerformanceByDifficultyChart: React.FC<Props> = (props) => {
  const loadingPlaceholder = (
    <BarChart
      borderRadius={8}
      chartProps={{ animate: false }}
      data={[
        { difficulty: 'Easy', 'Correct': 60, 'CorrectColor': colors.gray85, 'Incorrect': 40, 'IncorrectColor': colors.grayLightest },
        { difficulty: 'Medium', 'Correct': 40, 'CorrectColor': colors.gray85, 'Incorrect': 60, 'IncorrectColor': colors.grayLightest },
        { difficulty: 'Hard', 'Correct': 20, 'CorrectColor': colors.gray85, 'Incorrect': 80, 'IncorrectColor': colors.grayLightest },
        { difficulty: 'Very Hard', 'Correct': 0, 'CorrectColor': colors.gray85, 'Incorrect': 100, 'IncorrectColor': colors.grayLightest }
      ]}
      horizontal
      indexBy="difficulty"
    />
  );

  const formatStatisticData = (statisticData) => {
    const componentColors = {
      'Correct': colors.dataDarkBlue,
      'Incorrect': colors.dataMutedBlue
    };

    return statisticData.map((group) => {
      let result = { difficulty: group.name };

      group.components.forEach((component, idx) => {
        result[component.name] = component.value;

        const color = componentColors[component.name];
        if (color) {
          result[`${component.name}Color`] = color;
        }
      });

      return result;
    });
  };

  if (!props.filters) {
    return loadingPlaceholder;
  } else {
    return (
      <StatisticData
        filters={props.filters}
        formatDataFn={formatStatisticData}
        name="performance_by_difficulty"
      >
        <StatisticData.Loading>
          {loadingPlaceholder}
        </StatisticData.Loading>

        {/* @ts-ignore */}
        <BarChart
          borderRadius={8}
          chartProps={{ animate: false }}
          formatValueFn={(value) => `${value}%`}
          horizontal
          indexBy="difficulty"
        />
      </StatisticData>
    );
  }
};

export default PerformanceByDifficultyChart;
